import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ad998c1e&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=ad998c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad998c1e",
  null
  
)

export default component.exports